<template>
  <div class="vux-color-picker">
    <flexbox>
      <flexbox-item v-for="color in colors" :key="color"  class="vux-color-box">
        <span class="vux-color-item" :style="{borderRadius: width/2 + 'px',backgroundColor: color, width: width + 'px', height: width + 'px'}" @click="change(color)" :class="{'vux-color-white': color === '#fff' || color === '#fff', 'vux-color-picker-small': size === 'small', 'vux-color-picker-middle': size === 'middle'}">
          <icon v-if="color === value" class="vux-color-checked" :style="{lineHeight: width + 'px'}" type="success_no_circle"></icon>
        </span>
      </flexbox-item>
    </flexbox>
  </div>
</template>

<script>
import Icon from '../icon'
import Flexbox from '../flexbox'
import FlexboxItem from '../flexbox-item'

const sizeMap = {
  'large': 40,
  'middle': 30,
  'small': 20
}
export default {
  components: {
    Icon,
    Flexbox,
    FlexboxItem
  },
  props: {
    colors: {
      type: Array,
      required: true
    },
    size: {
      type: String,
      default: 'large'
    },
    value: String,
    enableNull: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      color: ''
    }
  },
  computed: {
    width () {
      return sizeMap[this.size]
    }
  },
  methods: {
    change (color) {
      if (this.color === color && this.enableNull) {
        color = ''
      }
      this.color = color
      // this.$emit('on-change', color)
    }
  },
  watch: {
    color (val) {
      this.$emit('input', val)
      this.$emit('on-change', val)
    },
    value (val) {
      this.color = val
    }
  }
}
</script>

<style lang="less">
@import '../../styles/cui/icon/cui_icon_font';

.vux-color-box {
  text-align: center;
}
.vux-color-picker {
  font-size: 0;
}
.vux-color-item {
  display: inline-block;
  text-align: center;
  box-sizing: border-box;
  position: relative
}
.vux-color-checked.weui_icon_success_no_circle:before {
  color: #fff;
}
.vux-color-checked {
  width: 100%;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.vux-color-white {
  border: 1px solid #ccc;
}
.vux-color-white .vux-color-checked:before {
  color: #ccc;
}
.vux-color-picker-small .vux-color-checked:before{
  font-size: 10px;
}
.vux-color-picker-middle .vux-color-checked:before{
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// color-picker.vue?350d4c58